
import Car from '../views/product/car/car'
import Category from '../views/product/category/category'
import ProductDetail from '../views/product/product-detail/product-detail'
import OrderList from '../views/product/order-list/order-list'
import SearchGoods from '../views/product/search-goods/search-goods'
import OrderDetail from '../views/product/order-detail/order-detail'
import ConfirmOrder from '../views/product/confirm-order/confirm-order'
import PaySuccess from '../views/product/pay-success/pay-success'
import Payment from '../views/product/payment/payment'
const ProductRouter = [
  // 购物车
  {
    path: '/car',
    name: 'car',
    component: Car,
    meta: { keepAlive: true }
  },
  // 分类
  {
    path: '/category',
    name: 'category',
    component: Category,
    meta: { keepAlive: true }
  },
  // 商品详情
  {
    path: '/product-detail',
    name: 'product-detail',
    component: ProductDetail
  },
  // 订单列表
  {
    path: '/order-list',
    name: 'order-list',
    component: OrderList,
    meta: { keepAlive: true }
  },
  // 订单详情
  {
    path: '/order-detail',
    name: 'order-detail',
    component: OrderDetail
  },
  // 搜索
  {
    path: '/search-goods',
    name: 'search-goods',
    component: SearchGoods,
    // meta: { keepAlive: true }
  },
  // 确定订单
  {
    path: '/confirm-order',
    name: 'confirm-order',
    component: ConfirmOrder
  },
  // 确认支付
  {
    path: '/payment',
    name: 'payment',
    component: Payment
  },
  // 支付成功
  {
    path: '/pay-success',
    name: 'pay-success',
    component: PaySuccess
  },
 
]

export default ProductRouter
